<template>
    <div :class="`sep ${name}`"></div>
</template>

<script>
    import Vue from "vue"

    export default Vue.extend({
        props: ["name"]
    })

</script>

<style lang="sass" scoped>
    .S 
        font-size: 0
        height: $padding-main/4

    .M
        font-size: 0
        height: $padding-main/2

        +r(480)
            height: $padding-main/4

    .L 
        font-size: 0
        height: $padding-main

        +r(480)
            height: $padding-main/2

    .XL 
        font-size: 0
        height: $padding-main*2

    @media print
        .S, .L, .XL
            display: none
</style>